import React from 'react';
import { AwardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { SectionHeading } from './ui/SectionHeading';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-surface py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-143" data-mp="1j9qpghfdfsh6">
      <div className="mx-auto max-w-3xl px-4" data-id="element-144" data-mp="1na0t3nfoy6sv">
        <SectionHeading id="pricing-title" data-id="element-145" data-mp="1s9dee3qwz5tc">Choose Your <span className="text-accent" data-id="element-146" data-mp="1s8c6u993x1gd">Option</span></SectionHeading>

        <article className="mt-10 overflow-hidden rounded-3xl border-2 border-cta bg-background shadow-2xl shadow-black/50" data-id="element-147" data-mp="1x86rhv2agusz">
          <div className="border-b border-primary/30 bg-surface/50 px-6 py-4 sm:px-10" data-id="element-148" data-mp="226i6ek7fxvi2">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary bg-primary/15 px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.14em] text-foreground" data-id="element-149" data-mp="2vqqp9s9i8vi">
              <AwardIcon className="h-3.5 w-3.5 text-accent" aria-hidden="true" data-id="element-150" data-mp="1mhq24evyzoiy" /> Main Offer
            </span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-151" data-mp="1hodbjz7qd7nk">
            <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-152" data-mp="1cqlnxhe4c7p6">
              <div data-id="element-153" data-mp="17rsb7r6nokq2">
                <h3 className="font-display text-3xl font-bold uppercase leading-tight tracking-tight text-foreground sm:text-4xl" data-id="element-154" data-mp="17saayxsj1h2q">{productShortName}</h3>
                <p className="mt-2 text-sm text-muted" data-id="element-155" data-mp="25dg4w4bq8oxw">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-156" data-mp="1vg1t4i0r0obx">
                <span className="text-sm text-muted" data-id="element-157" data-mp="1rg1a0k2pfoyj">
                  Regular price: <span className="line-through decoration-primary decoration-2" data-id="element-158" data-mp="1rhu83az950ux">{priceBefore}</span>
                </span>
                <p className="mt-2 text-xs font-bold uppercase tracking-[.14em] text-primary" data-id="element-159" data-mp="g0uhcjsjyu30">Today:</p>
                <p className="mt-1 whitespace-nowrap font-display text-6xl font-extrabold leading-none tracking-tight text-accent" data-id="element-160" data-mp="hi1bg00si2it">{price}</p>
              </div>
            </div>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-161" data-mp="mei85im21p7i">
              Get my professional edition now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-162" data-mp="cgu3o0ynd3c5">
              <span className="inline-flex items-center gap-1.5" data-id="element-163" data-mp="3uutiyojhn4tu">
                <LockIcon className="h-4 w-4 text-primary" aria-hidden="true" data-id="element-164" data-mp="3jjpa6qj8y30" /> Secure payment
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-165" data-mp="3l0bbr9ev4r5a">
                <ZapIcon className="h-4 w-4 text-primary" aria-hidden="true" data-id="element-166" data-mp="3pymkthxc2xmg" /> Instant access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-167" data-mp="3bybuqh3uln2c">
                <ShieldCheckIcon className="h-4 w-4 text-primary" aria-hidden="true" data-id="element-168" data-mp="3fzx61y0qhtaf" /> 7-day guarantee
              </span>
            </div>
          </div>
        </article>
      </div>
    </section>;
}